/* Powerenough: live search, cart drawer, recently viewed, announcement bar. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return [].slice.call((c || d).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(n) { return 'Rs. ' + Number(n).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function sized(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  var locks = 0;
  function lock() { if (locks++ === 0) { if (window.peLenis) window.peLenis.stop(); else root.style.overflow = 'hidden'; } }
  function unlock() { if (--locks <= 0) { locks = 0; if (window.peLenis) window.peLenis.start(); else root.style.overflow = ''; } }
  function toast(msg) { var t = d.createElement('div'); t.className = 'pe-toast'; t.setAttribute('role', 'alert'); t.textContent = msg; d.body.appendChild(t); setTimeout(function () { t.remove(); }, 4200); }

  /* announcement bar: header slides up with the bar, messages rotate on phones */
  var ann = $('[data-ann]');
  if (ann) {
    var H = ann.offsetHeight || 36, tick = false;
    var upd = function () { tick = false; root.style.setProperty('--barh', Math.max(0, H - (window.scrollY || 0)) + 'px'); };
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
    var msgs = $$('.pe-ann__msg', ann);
    if (msgs.length > 1) { var mi = 0; setInterval(function () { if (innerWidth >= 760) return; msgs[mi].classList.remove('is-on'); mi = (mi + 1) % msgs.length; msgs[mi].classList.add('is-on'); }, 3600); }
  }

  /* live search */
  var S = $('#pe-search');
  if (S) {
    var input = $('input[type=search]', S), res = $('.pe-search__res', S), hint = $('.pe-search__hint', S), isOpen = false, ctl, timer;
    var openS = function () { if (isOpen) return; isOpen = true; S.classList.add('is-open'); S.setAttribute('aria-hidden', 'false'); lock(); setTimeout(function () { input.focus(); }, 80); };
    var closeS = function () { if (!isOpen) return; isOpen = false; S.classList.remove('is-open'); S.setAttribute('aria-hidden', 'true'); unlock(); };
    $$('a.pe-icon-btn[aria-label="Search"]').forEach(function (a) { a.addEventListener('click', function (e) { if (location.pathname === '/search') return; e.preventDefault(); openS(); }); });
    $$('[data-close]', S).forEach(function (b) { b.addEventListener('click', closeS); });
    var render = function (q, r) {
      var rs = (r && r.resources && r.resources.results) || {}, p = rs.products || [], c = rs.collections || [], h = '';
      if (c.length) h += '<div class="pe-search__cols">' + c.map(function (x) { return '<a href="' + esc(x.url) + '">' + esc(x.title) + '</a>'; }).join('') + '</div>';
      if (p.length) h += '<ul class="pe-search__list">' + p.map(function (x) { return '<li><a href="' + esc(x.url) + '"><span class="pe-search__img">' + (x.image ? '<img src="' + esc(sized(x.image, 160)) + '" alt="" loading="lazy">' : '') + '</span><span class="pe-search__t"><small>' + esc(x.vendor) + '</small><b>' + esc(x.title) + '</b></span><span class="pe-search__p">' + money(x.price) + '</span></a></li>'; }).join('') + '</ul>';
      if (!p.length && !c.length) h = '<p class="pe-search__none">No matches for &ldquo;' + esc(q) + '&rdquo;. Try a brand or category.</p>';
      else h += '<a class="pe-search__all" href="/search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last">See all results for &ldquo;' + esc(q) + '&rdquo;</a>';
      res.innerHTML = h;
    };
    input.addEventListener('input', function () {
      var q = input.value.trim(); clearTimeout(timer);
      if (q.length < 2) { res.innerHTML = ''; hint.hidden = false; return; }
      hint.hidden = true;
      timer = setTimeout(function () {
        if (ctl) ctl.abort(); ctl = window.AbortController ? new AbortController() : null;
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=8&resources[options][unavailable_products]=last', ctl ? { signal: ctl.signal } : {})
          .then(function (r) { return r.json(); }).then(function (j) { render(q, j); }).catch(function () {});
      }, 220);
    });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeS(); closeD(); } });
  }

  /* cart drawer */
  var D = $('#pe-drawer');
  var dOpen = false;
  function openD() { if (!D || dOpen) return; dOpen = true; D.classList.add('is-open'); D.setAttribute('aria-hidden', 'false'); lock(); }
  function closeD() { if (!D || !dOpen) return; dOpen = false; D.classList.remove('is-open'); D.setAttribute('aria-hidden', 'true'); unlock(); }
  function badge(n) {
    $$('a.pe-icon-btn[aria-label^="Cart"]').forEach(function (a) {
      var b = $('.pe-count', a);
      if (n > 0) { if (!b) { b = d.createElement('span'); b.className = 'pe-count'; a.appendChild(b); } b.textContent = n; } else if (b) b.remove();
      a.setAttribute('aria-label', 'Cart, ' + n + ' items');
    });
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function renderCart(c) {
    var items = $('.pe-drawer__items', D), foot = $('.pe-drawer__foot', D);
    $('[data-count]', D).textContent = c.item_count ? '(' + c.item_count + ')' : '';
    if (!c.item_count) {
      items.innerHTML = '<div class="pe-drawer__empty"><p>Your cart is empty.</p><a class="pe-btn" href="/collections/all"><span>Start shopping</span></a></div>';
      foot.hidden = true;
    } else {
      items.innerHTML = c.items.map(function (it) {
        return '<div class="pe-dline"><a class="pe-dline__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(sized(it.image, 200)) + '" alt="">' : '') + '</a>' +
          '<div class="pe-dline__i"><a class="pe-dline__t" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + (it.variant_title && it.variant_title !== 'Default Title' ? '<small>' + esc(it.variant_title) + '</small>' : '') +
          '<div class="pe-dline__q"><button type="button" data-act="dec" data-key="' + esc(it.key) + '" data-q="' + it.quantity + '" aria-label="Decrease quantity">&minus;</button><span>' + it.quantity + '</span><button type="button" data-act="inc" data-key="' + esc(it.key) + '" data-q="' + it.quantity + '" aria-label="Increase quantity">+</button><button type="button" class="pe-dline__rm" data-act="rm" data-key="' + esc(it.key) + '">Remove</button></div></div>' +
          '<div class="pe-dline__tot">' + money(it.final_line_price / 100) + '</div></div>';
      }).join('');
      $('[data-sub]', D).textContent = money(c.total_price / 100);
      foot.hidden = false;
    }
    badge(c.item_count);
  }
  if (D) {
    $$('[data-close]', D).forEach(function (b) { b.addEventListener('click', closeD); });
    D.addEventListener('click', function (e) {
      var b = e.target.closest('[data-act]'); if (!b) return;
      var q = +b.dataset.q || 0, n = b.dataset.act === 'rm' ? 0 : b.dataset.act === 'inc' ? q + 1 : q - 1;
      D.classList.add('pe-drawer__busy');
      fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: b.dataset.key, quantity: Math.max(0, n) }) })
        .then(function (r) { return r.json(); }).then(function (c) { if (c.items) renderCart(c); else if (c.description) toast(c.description); })
        .catch(function () { toast('Could not update the cart. Please try again.'); })
        .then(function () { D.classList.remove('pe-drawer__busy'); });
    });
    $$('a.pe-icon-btn[aria-label^="Cart"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (location.pathname === '/cart') return;
        e.preventDefault(); getCart().then(function (c) { renderCart(c); openD(); }).catch(function () { location.href = '/cart'; });
      });
    });
    d.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.action || f.action.indexOf('/cart/add') < 0) return;
      var idEl = f.querySelector('[name=id]'), qtyEl = f.querySelector('[name=quantity]');
      if (!idEl) return;
      e.preventDefault();
      var btn = f.querySelector('[data-add]') || f.querySelector('[type=submit]'), lbl = btn && btn.querySelector('span'), old = lbl && lbl.textContent;
      if (btn) btn.disabled = true; if (lbl) lbl.textContent = 'Adding...';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: idEl.value, quantity: Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1) }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (x) {
          if (!x.ok) { toast(x.j.description || x.j.message || 'Could not add this item to the cart.'); return; }
          return getCart().then(function (c) { renderCart(c); openD(); });
        })
        .catch(function () { f.submit(); })
        .then(function () { if (btn) btn.disabled = false; if (lbl && old) lbl.textContent = old; });
    }, true);
  }

  /* recently viewed */
  var KEY = 'pe-recent', list = [];
  try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
  var m = location.pathname.match(/\/products\/([^\/?#]+)/), cur = m && m[1];
  if (cur) { list = [cur].concat(list.filter(function (h) { return h !== cur; })).slice(0, 12); try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  var host = cur ? $('[data-pdp]') : $('.pe-cart') && $('.pe-cart').parentNode;
  var want = list.filter(function (h) { return h !== cur; }).slice(0, 4);
  if (host && want.length) {
    Promise.all(want.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); })).then(function (ps) {
      ps = ps.filter(Boolean); if (!ps.length) return;
      var sec = d.createElement('div'); sec.className = 'pe-recent';
      sec.innerHTML = '<h2>Recently viewed</h2><div class="pe-grid">' + ps.map(function (p) {
        var sale = p.compare_at_price > p.price;
        return '<a class="pe-card" href="/products/' + esc(p.handle) + '"><div class="pe-card__shell"><div class="pe-card__media">' + (sale ? '<span class="pe-card__tag">Sale</span>' : '') + (p.featured_image ? '<img class="main" src="' + esc(sized(p.featured_image, 600)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</div><div class="pe-card__body"><p class="pe-card__vendor">' + esc(p.vendor) + '</p><h3 class="pe-card__title">' + esc(p.title) + '</h3><div class="pe-card__price">' + money(p.price / 100) + (sale ? '<s>' + money(p.compare_at_price / 100) + '</s>' : '') + '</div></div></div></a>';
      }).join('') + '</div>';
      host.appendChild(sec);
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
    });
  }
})();
